// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bas-summary {
  padding: 24px;
  background: #f8fafc;
  min-height: 100vh;
}
.bas-summary .bas-header {
  margin-bottom: 24px;
}
.bas-summary .bas-header h2 {
  margin: 0;
  font-size: 28px;
  font-weight: 700;
  color: #1e293b;
}
.bas-summary .summary-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 16px;
  margin-bottom: 24px;
}
.bas-summary .summary-cards .card {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}
.bas-summary .summary-cards .card h4 {
  margin: 0 0 10px;
  font-size: 13px;
  font-weight: 600;
  color: #64748b;
  text-transform: uppercase;
}
.bas-summary .summary-cards .card span {
  font-size: 28px;
  font-weight: 700;
  color: #0f172a;
}
.bas-summary .summary-cards .card.highlight {
  background: linear-gradient(135deg, #2563eb, #1d4ed8);
}
.bas-summary .summary-cards .card.highlight h4,
.bas-summary .summary-cards .card.highlight span {
  color: white;
}
.bas-summary .filters {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  align-items: center;
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 20px;
}
.bas-summary .filters select,
.bas-summary .filters input {
  height: 42px;
  padding: 0 12px;
  border-radius: 8px;
  border: 1px solid #cbd5e1;
  font-size: 14px;
  color: #1e293b;
  background: white;
}
.bas-summary .filters select:focus,
.bas-summary .filters input:focus {
  outline: none;
  border-color: #2563eb;
}
.bas-summary .tabs {
  display: flex;
  align-items: center;
  border-bottom: 2px solid #e2e8f0;
  margin-bottom: 20px;
  gap: 0;
}
.bas-summary .tabs button {
  background: transparent;
  border: none;
  padding: 14px 24px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  color: #334155 !important;
  position: relative;
  transition: all 0.2s ease;
}
.bas-summary .tabs button:hover {
  background: #f8fafc;
  color: #2563eb !important;
}
.bas-summary .tabs button.active {
  color: #2563eb !important;
  background: transparent;
}
.bas-summary .tabs button.active::after {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  bottom: -2px;
  height: 3px;
  background: #2563eb;
}
.bas-summary .bas-table {
  width: 100%;
  border-collapse: collapse;
  background: white;
  border-radius: 12px;
  overflow: hidden;
  margin-bottom: 20px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
}
.bas-summary .bas-table thead tr {
  background: #f1f5f9;
}
.bas-summary .bas-table thead th {
  background: #f1f5f9;
  color: #1e293b !important;
  text-align: left;
  padding: 14px;
  font-size: 13px;
  font-weight: 700;
  border-bottom: 2px solid #e2e8f0;
}
.bas-summary .bas-table tbody tr {
  border-bottom: 1px solid #e2e8f0;
}
.bas-summary .bas-table tbody tr:hover {
  background: #f8fafc;
}
.bas-summary .bas-table tbody tr td {
  padding: 14px;
  font-size: 14px;
  color: #334155;
}
.bas-summary .pagination {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;
}
.bas-summary .pagination button {
  border: none;
  background: #2563eb;
  color: white !important;
  padding: 10px 16px;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 600;
}
.bas-summary .pagination button:hover:not(:disabled) {
  background: #1d4ed8;
}
.bas-summary .pagination button:disabled {
  background: #cbd5e1;
  cursor: not-allowed;
}
.bas-summary .pagination span {
  font-weight: 600;
  color: #475569;
}

@media (max-width: 768px) {
  .bas-summary {
    padding: 12px;
  }
  .bas-summary .summary-cards {
    grid-template-columns: 1fr;
  }
  .bas-summary .filters {
    flex-direction: column;
    align-items: stretch;
  }
  .bas-summary .filters select,
  .bas-summary .filters input {
    width: 100%;
  }
  .bas-summary .tabs {
    overflow-x: auto;
    white-space: nowrap;
  }
  .bas-summary .tabs button {
    min-width: 180px;
  }
  .bas-summary .bas-table {
    display: block;
    overflow-x: auto;
    white-space: nowrap;
  }
  .bas-summary .pagination {
    justify-content: center;
    flex-wrap: wrap;
  }
}`, "",{"version":3,"sources":["webpack://./src/accounting/pages/accounting/BASSummary.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;AACF;AACE;EACE,mBAAA;AACJ;AACI;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AACN;AAGE;EACE,aAAA;EACA,2DAAA;EACA,SAAA;EACA,mBAAA;AADJ;AAGI;EACE,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,yCAAA;AADN;AAGM;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;AADR;AAIM;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AAFR;AAKM;EACE,qDAAA;AAHR;AASQ;;EAEE,YAAA;AAPV;AAaE;EACE,aAAA;EACA,eAAA;EACA,SAAA;EACA,mBAAA;EAEA,iBAAA;EACA,yBAAA;EACA,mBAAA;EACA,aAAA;EAEA,mBAAA;AAbJ;AAeI;;EAEE,YAAA;EACA,eAAA;EACA,kBAAA;EACA,yBAAA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;AAbN;AAeM;;EACE,aAAA;EACA,qBAAA;AAZR;AAiBE;EACE,aAAA;EACA,mBAAA;EACA,gCAAA;EACA,mBAAA;EACA,MAAA;AAfJ;AAiBI;EACE,uBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,yBAAA;AAfN;AAiBM;EACE,mBAAA;EACA,yBAAA;AAfR;AAkBM;EACE,yBAAA;EACA,uBAAA;AAhBR;AAkBQ;EACE,WAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;AAhBV;AAsBE;EACE,WAAA;EACA,yBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,0CAAA;AApBJ;AAuBM;EACE,mBAAA;AArBR;AAwBM;EACE,mBAAA;EACA,yBAAA;EACA,gBAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,gCAAA;AAtBR;AA2BM;EACE,gCAAA;AAzBR;AA2BQ;EACE,mBAAA;AAzBV;AA4BQ;EACE,aAAA;EACA,eAAA;EACA,cAAA;AA1BV;AAgCE;EACE,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,SAAA;AA9BJ;AAgCI;EACE,YAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;AA9BN;AAgCM;EACE,mBAAA;AA9BR;AAiCM;EACE,mBAAA;EACA,mBAAA;AA/BR;AAmCI;EACE,gBAAA;EACA,cAAA;AAjCN;;AAsCA;EACE;IACE,aAAA;EAnCF;EAqCE;IACE,0BAAA;EAnCJ;EAsCE;IACE,sBAAA;IACA,oBAAA;EApCJ;EAsCI;;IAEE,WAAA;EApCN;EAwCE;IACE,gBAAA;IACA,mBAAA;EAtCJ;EAwCI;IACE,gBAAA;EAtCN;EA0CE;IACE,cAAA;IACA,gBAAA;IACA,mBAAA;EAxCJ;EA2CE;IACE,uBAAA;IACA,eAAA;EAzCJ;AACF","sourcesContent":[".bas-summary {\n  padding: 24px;\n  background: #f8fafc;\n  min-height: 100vh;\n\n  .bas-header {\n    margin-bottom: 24px;\n\n    h2 {\n      margin: 0;\n      font-size: 28px;\n      font-weight: 700;\n      color: #1e293b;\n    }\n  }\n\n  .summary-cards {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n    gap: 16px;\n    margin-bottom: 24px;\n\n    .card {\n      background: #ffffff;\n      border: 1px solid #e2e8f0;\n      border-radius: 12px;\n      padding: 20px;\n      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);\n\n      h4 {\n        margin: 0 0 10px;\n        font-size: 13px;\n        font-weight: 600;\n        color: #64748b;\n        text-transform: uppercase;\n      }\n\n      span {\n        font-size: 28px;\n        font-weight: 700;\n        color: #0f172a;\n      }\n\n      &.highlight {\n        background: linear-gradient(\n          135deg,\n          #2563eb,\n          #1d4ed8\n        );\n\n        h4,\n        span {\n          color: white;\n        }\n      }\n    }\n  }\n\n  .filters {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 12px;\n    align-items: center;\n\n    background: white;\n    border: 1px solid #e2e8f0;\n    border-radius: 12px;\n    padding: 16px;\n\n    margin-bottom: 20px;\n\n    select,\n    input {\n      height: 42px;\n      padding: 0 12px;\n      border-radius: 8px;\n      border: 1px solid #cbd5e1;\n      font-size: 14px;\n      color: #1e293b;\n      background: white;\n\n      &:focus {\n        outline: none;\n        border-color: #2563eb;\n      }\n    }\n  }\n\n  .tabs {\n    display: flex;\n    align-items: center;\n    border-bottom: 2px solid #e2e8f0;\n    margin-bottom: 20px;\n    gap: 0;\n\n    button {\n      background: transparent;\n      border: none;\n      padding: 14px 24px;\n      cursor: pointer;\n      font-size: 14px;\n      font-weight: 600;\n      color: #334155 !important;\n      position: relative;\n      transition: all 0.2s ease;\n\n      &:hover {\n        background: #f8fafc;\n        color: #2563eb !important;\n      }\n\n      &.active {\n        color: #2563eb !important;\n        background: transparent;\n\n        &::after {\n          content: \"\";\n          position: absolute;\n          left: 0;\n          right: 0;\n          bottom: -2px;\n          height: 3px;\n          background: #2563eb;\n        }\n      }\n    }\n  }\n\n  .bas-table {\n    width: 100%;\n    border-collapse: collapse;\n    background: white;\n    border-radius: 12px;\n    overflow: hidden;\n    margin-bottom: 20px;\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);\n\n    thead {\n      tr {\n        background: #f1f5f9;\n      }\n\n      th {\n        background: #f1f5f9;\n        color: #1e293b !important;\n        text-align: left;\n        padding: 14px;\n        font-size: 13px;\n        font-weight: 700;\n        border-bottom: 2px solid #e2e8f0;\n      }\n    }\n\n    tbody {\n      tr {\n        border-bottom: 1px solid #e2e8f0;\n\n        &:hover {\n          background: #f8fafc;\n        }\n\n        td {\n          padding: 14px;\n          font-size: 14px;\n          color: #334155;\n        }\n      }\n    }\n  }\n\n  .pagination {\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n    gap: 12px;\n\n    button {\n      border: none;\n      background: #2563eb;\n      color: white !important;\n      padding: 10px 16px;\n      border-radius: 8px;\n      cursor: pointer;\n      font-weight: 600;\n\n      &:hover:not(:disabled) {\n        background: #1d4ed8;\n      }\n\n      &:disabled {\n        background: #cbd5e1;\n        cursor: not-allowed;\n      }\n    }\n\n    span {\n      font-weight: 600;\n      color: #475569;\n    }\n  }\n}\n\n@media (max-width: 768px) {\n  .bas-summary {\n    padding: 12px;\n\n    .summary-cards {\n      grid-template-columns: 1fr;\n    }\n\n    .filters {\n      flex-direction: column;\n      align-items: stretch;\n\n      select,\n      input {\n        width: 100%;\n      }\n    }\n\n    .tabs {\n      overflow-x: auto;\n      white-space: nowrap;\n\n      button {\n        min-width: 180px;\n      }\n    }\n\n    .bas-table {\n      display: block;\n      overflow-x: auto;\n      white-space: nowrap;\n    }\n\n    .pagination {\n      justify-content: center;\n      flex-wrap: wrap;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
